export const ID_PREFIX = {
  AGENT_SESSION: "mem_agentsession_",
  AGENT_SESSION_EVENT: "mem_agentsessionevent_",
  MEMORY: "mem_memory_",
  PROJECT: "mem_project_",
  REVISION: "mem_revision_",
  TRIGGER: "mem_trigger_",
} as const;
